import { CanActivateFn } from '@angular/router';
import { canActivateAuthGuard } from '@okta/okta-angular';

export const authGuard: CanActivateFn = (route, state) => canActivateAuthGuard(route, state);
